// extracted by mini-css-extract-plugin
module.exports = {"reportBody":"style__reportBody__O4Ecu","pageBody":"style__pageBody__pZipb","reportText":"style__reportText__Yw9fJ","feedback":"style__feedback__-Q00j"};